module.exports = __webpack_public_path__ + "static/media/genwest-small-banner-image-1x.3ed993b3.jpg";